import { PlayerStateHelper } from 'State/Player/PlayerStateHelper';
import Game from '../../../Game';
import { IGameState } from '../../../State/Game/IGameState';
import { IRewardData } from '../../RewardHelper';
import { TActionType, TransactionType } from '../DataSet/Transaction';
import { FBTrackingEvent } from '../FBTrackingEvent';
import { sendEvent, track } from '../Track';
import { FTUXTrackingEventName } from '../TrackingEvent';
import { trackReward } from './Resource';
import { trackResourceEvent } from './Transaction';
import { report } from '../../../report';

export class PlayerTrackingHelper {
    public static trackHarvest(state: IGameState, rewardData: IRewardData): IGameState {
        let newState = { ...state };
        try {
            trackReward(rewardData);
            trackResourceEvent(state, {
                transactionType: TransactionType.REWARD,
                tActionType: TActionType.HARVEST,
            });
    
            if (
                !state.playerState.FBEvents.includes(
                    FBTrackingEvent.FTUE_16_CollectButtonClicked
                )
            ) {
                Game.sdk.gameTracking(FBTrackingEvent.CompleteTutorial);
                Game.sdk.gameTracking(FBTrackingEvent.FTUE_16_CollectButtonClicked);
                
                newState = PlayerStateHelper.addFBTrackingEvent(
                    newState,
                    FBTrackingEvent.FTUE_16_CollectButtonClicked
                );
    
                track('stepId', 16);
                track('stepName', FBTrackingEvent.FTUE_16_CollectButtonClicked);
                sendEvent(FTUXTrackingEventName.ftux, state);
            }
        }
        catch (error) {
            report("Failed to track harvest", {
                error,
                sampleRate: 0.1,
                once: true,
                state: newState
            });
        }

        return newState;
    }
}
